/**
 * Number of things a buyer can download: the product's files plus its Forge
 * remix link (helpers/forge-remix.js), which Forge products may have instead
 * of any file. Search records only carry has_files, which counts as one.
 */
angular.module("UI8.filters").filter("ui8Deliverables", [
  function () {
    return function (product) {
      if (!product) return 0;
      var files =
        product.files && product.files.length
          ? product.files.length
          : product.has_files
          ? 1
          : 0;
      var remix =
        window.UI8 &&
        window.UI8.forgeRemix &&
        (product.compatibility || []).indexOf("Forge") !== -1
          ? 1
          : 0;
      return files + remix;
    };
  },
]);
